import React from 'react';

// Neural-node hexagon mark — three connected nodes inside a hex, representing
// applied-AI engineering. Replaces the old "NO" monogram.
export function LogoMark({ size = 32, animated = false }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={animated ? { animation: 'logoFloat 4s ease-in-out infinite' } : undefined}>
      <defs>
        <linearGradient id="neuralopsGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#00e0ff" />
          <stop offset="100%" stopColor="#0080ff" />
        </linearGradient>
      </defs>
      <polygon points="24,3 42,13.5 42,34.5 24,45 6,34.5 6,13.5"
        stroke="url(#neuralopsGrad)" strokeWidth="2" fill="rgba(0,212,255,0.06)" strokeLinejoin="round" />
      <line x1="24" y1="16" x2="15" y2="31" stroke="url(#neuralopsGrad)" strokeWidth="1.5" opacity="0.7" />
      <line x1="24" y1="16" x2="33" y2="31" stroke="url(#neuralopsGrad)" strokeWidth="1.5" opacity="0.7" />
      <line x1="15" y1="31" x2="33" y2="31" stroke="url(#neuralopsGrad)" strokeWidth="1.5" opacity="0.7" />
      <circle cx="24" cy="16" r="3.4" fill="url(#neuralopsGrad)" />
      <circle cx="15" cy="31" r="3.4" fill="url(#neuralopsGrad)" />
      <circle cx="33" cy="31" r="3.4" fill="url(#neuralopsGrad)" />
    </svg>
  );
}

// Full lock-up: mark + NEURALOPS wordmark (+ optional subtitle).
export default function Logo({ size = 'md', subtitle = true, animated = false }) {
  const markSize = size === 'lg' ? 44 : size === 'sm' ? 22 : 30;
  const fontSize = size === 'lg' ? 24 : size === 'sm' ? 14 : 17;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <LogoMark size={markSize} animated={animated} />
      <div>
        <div style={{ fontFamily: 'Orbitron', fontWeight: 800, fontSize, color: 'var(--j1)', letterSpacing: 3, lineHeight: 1, textShadow: '0 0 15px var(--glow1)' }}>
          NEURAL<span style={{ color: 'var(--txt2)' }}>OPS</span>
        </div>
        {subtitle && <div style={{ fontSize: 8, color: 'var(--txt2)', fontFamily: 'Share Tech Mono', letterSpacing: 2, marginTop: 3 }}>AI CENTER OF EXCELLENCE</div>}
      </div>
    </div>
  );
}
